import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { blogAPI } from '../../services/api';
import { useLanguage } from '../../context/LanguageContext';
import './Public.css';

const BlogDetail = () => {
  const { id } = useParams();
  const { formatDate } = useLanguage();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchPost();
  }, [id]);

  const fetchPost = async () => {
    try {
      const response = await blogAPI.getPost(id);
      setPost(response.data);
    } catch (err) {
      setError('無法載入文章');
      console.error('Error fetching post:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatPostDate = (dateString) => formatDate(dateString, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  if (loading) {
    return (
      <div className="public-page">
        <div className="container">
          <div className="loading-spinner">載入中...</div>
        </div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="public-page">
        <div className="container">
          <div className="alert alert-error">{error || '找不到文章'}</div>
          <Link to="/blog" className="btn btn-secondary">返回最新消息</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="public-page">
      <div className="page-header">
        <div className="container">
          <h1>{post.title}</h1>
          <p className="page-subtitle">
            {post.category && <span className="badge badge-info">{post.category}</span>}
            <span style={{marginLeft: '1rem'}}>{formatPostDate(post.published_date)}</span>
          </p>
        </div>
      </div>

      <div className="container">
        <div className="breadcrumb">
          <Link to="/">首頁</Link> / <Link to="/blog">最新消息</Link> / {post.title}
        </div>

        <article className="blog-detail card">
          {post.video && (
            <div className="blog-detail-video">
              <video src={post.video} controls playsInline preload="metadata" />
            </div>
          )}
          {post.featured_image && (
            <div className="blog-detail-image">
              <img src={post.featured_image} alt={post.title} />
            </div>
          )}

          <div className="blog-detail-content">
            {post.summary && (
              <p className="blog-summary">{post.summary}</p>
            )}
            
            <div className="blog-body" dangerouslySetInnerHTML={{ __html: post.content || '' }} />
          </div>

          <div className="blog-detail-footer">
            <div className="blog-meta">
              {post.author_name && <span>作者：{post.author_name}</span>}
              <span>瀏覽次數：{post.views_count || 0}</span>
            </div>
            
            <Link to="/blog" className="btn btn-outline">返回最新消息</Link>
          </div>
        </article>
      </div>
    </div>
  );
};

export default BlogDetail;
